import styled from '@emotion/styled';
import { Color } from '../../../styles/Color';
import { Css, SearchIcon } from '../../../ui';

export function SearchEmptyState() {
	return (
		<Wrapper>
			<StyledSearchIcon />
			<Description>Search for information by using keywords</Description>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	text-align: center;
	align-items: center;
	gap: ${Css.pxToRem(16)};
	margin-top: ${Css.pxToRem(120)};
`;

const Description = styled.h5`
	margin-bottom: ${Css.pxToRem(20)};
	max-width: 280px;
	color: ${Color.Neutral6};
`;

export const StyledSearchIcon = styled(SearchIcon)`
	width: ${Css.pxToRem(40)};
	height: ${Css.pxToRem(40)};

	path {
		fill: ${Color.Neutral6};
	}
`;
